/**
 * Shared Quasar brand color configuration.
 * Pass this into app.use(Quasar, { config: { brand: esignBrand } })
 * so Quasar initializes with our indigo theme instead of its blue defaults.
 */

// Side-effect import: mutates QDialog default prop values so every dialog
// in the portal uses a snappy 150ms fade instead of Quasar's default 300ms
// scale. esignBrand.js is imported by every page entry .js, so hooking the
// override here is the single-source-of-truth route. See the file's own
// comment block for the full rationale.
import '../Util/quasarDialogDefaults.js';

export default {
    primary: '#6366F1',
    secondary: '#64748B',
    accent: '#F59E0B',
    positive: '#10B981',
    negative: '#EF4444',
    info: '#3B82F6',
    warning: '#F59E0B',
    dark: '#1E1B4B',
    'dark-page': '#1E1B4B'
};
